export default __webpack_public_path__ + "8b3e674982aaea4dfd149cf2c5c9bbdb.png";